<template>
  <appTable
    v-if="shouldRenderConfig"
    :tableName="name"
    :tableClass="getClassName"
  >
    <appSummary></appSummary>
  </appTable>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    name: () => {
      return "Summary";
    }
  }
};
</script>
